import * as angular from 'angular';
import 'angular-ui-router';
import { SentryClient } from 'monitoring-error-handler';
import marketplaceList from './list';
import markeplace from './marketplaceList';
import { AccordionSelectViewComponent } from './accordionSelect/AccordionSelectView.component';
import { MarketplaceService } from './MarketplaceService';
export default angular
    .module('marketplace', [
    'ui.router',
    'ngResource',
    markeplace,
    marketplaceList,
])
    .service('MarketplaceService', MarketplaceService)
    .component('accordionSelect', AccordionSelectViewComponent)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('auth.marketplace', {
            abstract: true,
            template: '<ui-view></ui-view>',
            resolve: {
                isUserInitialized: async (AccountService2, InitializeUserService) => {
                    const me = await AccountService2.me();
                    await InitializeUserService.initFeatureToggle();
                    SentryClient.identifyUser({
                        email: me.email,
                        id: me.identity.toString(),
                    });
                },
            },
        });
    }])
    .name;
